import { createLabeledMessages } from '../../../messageUtils';
const logout = {
    logout: 'Boli ste odhlásení z aplikácie',
    logAgain: 'Znovu prihlásiť',
    confirmLogout: 'Budete presmerovaní na obrazovku odhlásenia a vaša relácia bude zrušená.'
};
export default Object.assign({}, logout, createLabeledMessages(logout));
